import strings from '../../../../../common/Translation/Translate';

export const getReceivableTypeLabel = (type: string) => {
  switch (type) {
    case 'BILL_TO_COMPANY':
      return strings.receivable_type_billToCompany;
    case 'CITY_LEDGER':
      return strings.receivable_type_cityLedger;
    default:
      return type || '—';
  }
};
